"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../utils/utils");
var csrf_token_1 = require("../utils/csrf-token");
var html_components_1 = require("../html-components");
var notification_container;
var shown_notification_message_ids = [];
function init() {
    document.addEventListener('notifications.show', show_notification);
    document.addEventListener('notifications.discard', discard_notification);
    init_notification_message_ids();
}
exports.init = init;
function init_notification_message_ids() {
    var message_elements = document.querySelectorAll('.notification-message');
    for (var i = 0; i < message_elements.length; ++i) {
        var message_element = message_elements.item(i);
        if (!message_element)
            continue;
        var notification_id = message_element.getAttribute('data-notification-id');
        if (!notification_id)
            continue;
        shown_notification_message_ids.push(parseInt(notification_id));
    }
}
function discard_notification(event) {
    if (!(event instanceof CustomEvent))
        return;
    var original_event = event.detail.original_event;
    if (!(original_event instanceof MouseEvent))
        return;
    var target = event.detail.target;
    if (!(target instanceof HTMLElement))
        return;
    var href = target.getAttribute('data-href');
    if (!href)
        return;
    var notification_element = (0, utils_1.get_parent_element_by_class)(target, 'notification-message');
    if (!notification_element)
        return;
    send_discard_notification_request(href)
        .then(function () {
        load_next_notification_message(notification_element);
        remove_notification_message(notification_element);
    })
        .catch(function () {
        window.alert('Server Failed');
    });
}
function show_notification(event) {
    if (!(event instanceof CustomEvent))
        return;
    var original_event = event.detail.original_event;
    if (!(original_event instanceof MouseEvent))
        return;
    var target = event.detail.target;
    if (!(target instanceof HTMLElement))
        return;
    var href = target.getAttribute('data-href');
    if (!href)
        return;
    var success = open_link(original_event.button, href);
    if (success) {
        var notification_element = (0, utils_1.get_parent_element_by_class)(target, 'notification-message');
        if (!notification_element)
            return;
        mark_notification_message_as_read(notification_element);
    }
}
function open_link(button, href) {
    switch (button) {
        case 0:
            window.location.href = href;
            break;
        case 1:
            window.open(href, '_blank');
            break;
        default:
            return false;
    }
    return true;
}
function mark_notification_message_as_read(element) {
    var state_element = element.querySelector('.notification-message__state');
    if (!(state_element instanceof HTMLElement))
        return;
    state_element.classList.remove('js-unread');
    state_element.classList.add('js-read');
}
function send_discard_notification_request(href) {
    return fetch(href, {
        headers: (0, csrf_token_1.get_csrf_token_header)()
    }).then(function (response) {
        return response.json();
    }).then(function (json) {
        if (!json.hasOwnProperty('success'))
            return Promise.reject();
        if (json.success !== true)
            return Promise.reject();
        return json;
    });
}
function remove_notification_message(element) {
    var li_element = element.parentElement;
    if (!(li_element instanceof HTMLElement))
        return element.remove();
    li_element.remove();
}
function load_next_notification_message(notification_element) {
    var notification_container = (0, utils_1.get_parent_element_by_class)(notification_element, 'notification-container');
    if (notification_container === null)
        return;
    var notification_ids = 'ids=' + shown_notification_message_ids.join(',');
    fetch('/notifications/next?' + notification_ids, {
        headers: (0, csrf_token_1.get_csrf_token_header)()
    }).then(function (response) {
        if (response.status !== 200)
            return Promise.reject();
        return response.text();
    }).then(function (html) {
        var _a;
        var notification_list_element = document.createElement('li');
        notification_list_element.innerHTML = html;
        var notification_element = notification_list_element.firstElementChild;
        if (!(notification_element instanceof HTMLElement))
            return Promise.reject();
        shown_notification_message_ids.push(parseInt((_a = notification_element.getAttribute('data-notification-id')) !== null && _a !== void 0 ? _a : ''));
        if (!(notification_list_element instanceof HTMLElement))
            return Promise.reject();
        notification_container.append(notification_list_element);
        (0, html_components_1.attach_html_component_functionality_to_element)(notification_list_element);
    }).catch(function () {
        // No further Notifications => fine
        if (notification_container.childElementCount === 0) {
            var notification_list_element = document.createElement('li');
            notification_list_element.innerHTML = '<div class="p-2 flex justify-center items-center">'
                + 'Keine ungelesenen Benachrichtigungen.'
                + '</div>';
            notification_container.append(notification_list_element);
        }
    });
}
